import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {Constant} from "../../../common/constant";
import {DataService} from "../../../common/service/data.service";
import {FormBuilder, FormControl, NgForm, Validators} from "@angular/forms";
import { ShortcutService } from "../../../common/service/shortcut.service";
import { UserProfile } from "src/app/common/models/users.model";
import { AppQueries, Dispatcher, GetInfoUser, OpenOTP, SetDataOTP } from "src/app/state";
import { Subscription } from "rxjs";
import { EventManagerService } from "src/app/common/service/event-manager.service";
import { DialogService } from "src/app/common/service/dialog.service";
import { TranslateService } from "@ngx-translate/core";
import { InvestorService } from "../../services/investor.service";

@Component({
  selector:"change-mail",
  templateUrl : "./change-mail.html",
  styleUrls: [
    './change-mail.scss'
  ],
})

export class ChangeMail implements OnInit, AfterViewInit, OnDestroy {
  public editForm = this.fb.group({
    currentMail: new FormControl({value: '', disabled: true}, Validators.required),
    newMail: ['', [Validators.required, Validators.pattern('^[_.A-Za-z0-9-]+@[_.A-Za-z0-9-]+$')]],
  });
  public Constant = Constant;
  currentProfile:any = {};
  isValidated: any;
  errors: any = {};
  isSaved = false;
  user: UserProfile = new UserProfile();
  subscriptions?: Subscription[] = [];
  step: any = 1;
  constructor(
    private fb: FormBuilder,
    private investorService: InvestorService,
    public eventManager: EventManagerService,
    public dataService:DataService,
    private appQueries: AppQueries,
    private dialogService: DialogService,
    private translate: TranslateService,
    private dispatcher: Dispatcher,
  ) {

  }

  ngOnInit() {
    this.subscriptions.push(
      this.appQueries.userProfile$
      .subscribe((userProfile) => {
        this.user = userProfile;
        this.editForm.patchValue({
          currentMail:  this.user.email,
        });
      }),
    )
  }
  ngOnDestroy() {
    this.eventManager.destroys(this.subscriptions);
  }
  ngAfterViewInit() {
    ShortcutService.addOneKey(13, this.save.bind(this));
  }
  disabledButton() {
    const currentMail = (this.editForm.get('currentMail').value || '').trim();
    if (currentMail && currentMail !== this.user.email) {
      this.errors.currentMail = true;
    } else {
      this.errors.currentMail = false;
    }
    const keys = Object.keys(this.errors);
    const key = keys.find(key => this.errors[key]);
    return key ? true : false;
  }

  save() {
    this.isSaved = true;
    const result = this.disabledButton();
    if (result || this.editForm.invalid) {
      return;
    }
    let requestBody = {
      email: (this.editForm.get('newMail').value || '').trim(),
    }
  }
  hasPendingProfile() {
    return this.user.pendingProfileCounter && this.user.pendingProfileCounter['EMAIL'] > 0;
  }
}
